import { HttpErrorResponse } from '@angular/common/http';

/** Copy (es-AR) for the error codes of roles, access and ownership. */
export const ACCESS_ERROR_MESSAGES: Readonly<Record<string, string>> = {
  PERMISSION_DENIED:
    'No tenés permiso para hacer esto. Si lo necesitás, pedíselo al Dueño de tu empresa.',
  OWNER_ONLY: 'Esto solo lo puede hacer el Dueño de la empresa.',
  UNKNOWN_PERMISSION:
    'Actualizamos la lista de permisos. Revisá los cambios y probá de nuevo.',
  UNKNOWN_ROLE:
    'Actualizamos la lista de permisos. Revisá los cambios y probá de nuevo.',
  OWNER_ACCESS_IMMUTABLE:
    'El Dueño tiene acceso total y no se puede modificar.',
  OWNER_CANNOT_BE_DEACTIVATED:
    'El Dueño tiene acceso total y no se puede modificar.',
  CANNOT_DELETE_SELF: 'No podés eliminarte a vos mismo.',
  ACCESS_MIGRATION_PENDING:
    'Estamos terminando de actualizar los accesos de tu empresa. Probá de nuevo en un rato.',
  EXCLUSIVE_PERMISSION_NOT_ASSIGNABLE:
    'Ese permiso es exclusivo del Dueño y no se puede asignar.',
  PERMISSION_CONFLICT:
    'Hay permisos en conflicto. Revisá los cambios y probá de nuevo.',
  USER_WITHOUT_ACCESS: 'Elegí al menos un rol o un permiso.',
  USER_LIMIT_REACHED:
    'No hay lugar para reactivar a esta persona. Desactivá a otra para liberar un lugar.',
  USER_INVITATION_RESEND_THROTTLED:
    'Ya enviamos una invitación hace instantes. Esperá un minuto para reenviarla.',
  OWNERSHIP_CODE_INVALID:
    'El código no es correcto. Revisalo y probá de nuevo.',
  OWNERSHIP_CODE_EXPIRED: 'El código venció. Pedí uno nuevo.',
  OWNERSHIP_CODE_ATTEMPTS_EXCEEDED:
    'Superaste los intentos permitidos. Pedí un código nuevo.',
  OWNERSHIP_RATE_LIMITED:
    'Pediste demasiados códigos. Probá de nuevo en una hora.',
  OWNERSHIP_TARGET_INVALID:
    'Esa persona ya no puede recibir la titularidad (la desactivaron o cambió). Elegí a otra.',
  OWNERSHIP_CHANGED:
    'La titularidad cambió mientras tanto. Actualizamos tu sesión.',
};

export const SERVER_ERROR_SAVE_MESSAGE =
  'No pudimos guardar. Probá de nuevo en un momento.';

/** `code` of the API error envelope, or '' when there is none. */
export function getApiErrorCode(error: unknown): string {
  if (!(error instanceof HttpErrorResponse)) return '';
  const body: unknown = error.error;
  if (typeof body !== 'object' || body === null) return '';
  const code = (body as { code?: unknown }).code;
  return typeof code === 'string' ? code : '';
}

/** Copy for an error code, or `fallback` when the code has none. */
export function accessErrorMessage(error: unknown, fallback = ''): string {
  const code = getApiErrorCode(error);
  if (ACCESS_ERROR_MESSAGES[code]) return ACCESS_ERROR_MESSAGES[code];
  if (error instanceof HttpErrorResponse && error.status >= 500) {
    return SERVER_ERROR_SAVE_MESSAGE;
  }
  return fallback;
}

export function isPermissionDeniedError(error: unknown): boolean {
  return (
    error instanceof HttpErrorResponse &&
    error.status === 403 &&
    ['PERMISSION_DENIED', 'OWNER_ONLY'].includes(getApiErrorCode(error))
  );
}
